// Firm unavailable (firm-lifecycle authorization hardening, 2026-10-05).
//
// Shown instead of the app shell when the signed-in member's firm is not
// operational (archived / deleted / missing). Firm data is no longer
// authorised for it, so the shell would only show permission errors. Offers
// sign-out and — where legitimate invitations exist — the explicit invitation
// chooser (accepting one is an explicit, server-checked move). Never reveals
// lifecycle internals, never bootstraps or unarchives anything.
import React from 'react';
import PendingInvitations from './PendingInvitations';

const FirmUnavailable = ({ invites = [], currentFirmId = null, displayName = '', onSignOut }) => (
  <div style={{ minHeight: '100vh', background: '#080a10', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', boxSizing: 'border-box', fontFamily: "'DM Sans', sans-serif" }}>
    <div style={{ maxWidth: '520px', width: '100%', textAlign: 'center' }}>
      <h2 style={{ color: '#e8eaed', margin: '0 0 0.75rem' }}>Firm unavailable</h2>
      <p style={{ color: '#8b8fa3', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
        Your firm is not currently available on FirmAssist, so its matters, clients and documents can't be opened.
        If you believe this is a mistake, please contact FirmAssist support.
      </p>
      {invites.length > 0 && (
        <div style={{ textAlign: 'left', marginBottom: '1.5rem' }}>
          <PendingInvitations invites={invites} currentFirmId={currentFirmId} displayName={displayName} onAccepted={() => window.location.reload()} />
        </div>
      )}
      <button type="button" onClick={onSignOut} style={{ padding: '0.75rem 2rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '10px', color: '#e8eaed', cursor: 'pointer', fontSize: '0.9rem', fontFamily: 'inherit' }}>
        Sign Out
      </button>
    </div>
  </div>
);

// Client mirror of the server/rules lifecycle predicate: operational only when the
// firm document exists with status absent or exactly 'active'. Canonical copy
// lives in the session model (session & auth-state handling, 2026-10-06).
export { isFirmOperational } from '../session/sessionModel';

export default FirmUnavailable;
